import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileManagementService } from '../../../../shared/services/file-management.service';
import { downloadIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { OfflineAttachment } from '../../models/offline-attachments';
import { AttachmentService } from '../../services/attachments.service';
import { CertificateService } from '../../services/certificate.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { StringConstants } from '@app/shared/string-constants';
import { TaskNotification } from '../../models/task-notification';

@Component({
	selector: 'kpa-offlinetraining',
	templateUrl: './offlinetraining.component.html',
	styleUrl: './offlinetraining.component.scss',
})
export class OfflinetrainingComponent {
	@Input() dialogOpened: boolean = false;
	@Input() offlineAttachments: OfflineAttachment[];
	@Output() dialogOpenedChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() closeDialog = new EventEmitter();
	@Output() onTaskComplete: EventEmitter<TaskNotification> = new EventEmitter<TaskNotification>();
	isReadConfirmation: boolean = false;
	constructor(
		private fileManagementService: FileManagementService,
		private attachmentService: AttachmentService,
		private certificateService: CertificateService,
		private notificationService: NotificationService
	) {}

	public downloadIcon: SVGIcon = downloadIcon;
	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public completeOfllineTraining() {
		this.attachmentService.postOfflineAttachments(this.offlineAttachments).subscribe((result: boolean) => {
			if (result) {
				const allReadConfirmed = this.offlineAttachments.every((attachment) => attachment.readConfirmation === true);
				const allNeedToReviewed  = this.offlineAttachments.every((attachment) => attachment.completeOnceDocsReviewed === false);
				this.dialogOpenedChange.emit();
				let taskNotification: TaskNotification;

				if (allReadConfirmed) {
					if (allNeedToReviewed) {
						taskNotification = { isCompleted: false, isReviewed: true };
					} else {
						taskNotification = { isCompleted: true, isReviewed: false };
					}
				} else {
					taskNotification = { isCompleted: false, isReviewed: false };
				}
				this.onTaskComplete.emit(taskNotification);
				this.dialogOpened = false;
			}
		});
	}
	public get isReadDocEnabled(): boolean {
		return this.offlineAttachments.some((attachment) => attachment.readConfirmation === true);
	}
	public downloadFileByFileId(attachment: OfflineAttachment) {
		if (attachment.fileId) {
			this.fileManagementService.downloadFileByFileId(attachment.fileId).subscribe({
				next: (response) => {
					this.certificateService.downloadCert(attachment.title, response);

					// Update readConfirmDisplay for the specific attachment
					const foundAttachmentIndex = this.offlineAttachments.findIndex((x) => x.fileId === attachment.fileId);
					if (foundAttachmentIndex !== -1) {
						const updatedAttachment = {
							...this.offlineAttachments[foundAttachmentIndex],
							readConfirmationDisplay: true,
						};
						this.offlineAttachments[foundAttachmentIndex] = updatedAttachment;
					}
				},
				error: (err) => {
					this.notificationService.show({
						content: 'Error while downloading document.',
						hideAfter: StringConstants.hideNotificationAfter,
						position: { horizontal: 'right', vertical: 'bottom' },
						animation: { type: 'fade', duration: 400 },
						type: { style: 'error', icon: true },
					});
				},
			});
		}
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.closeDialog.emit();
	}
}
